import { getEndPoint } from './getEndPoint'
export const getBlogCategories = () => getEndPoint('wp/v2/categories')
